<payee-popup
  title="Új értesítés létrehozása"
  width="700px"
>
  @if (dataReady) {
    <form [formGroup]="form">
      <div class="dialog-content flex column vcenter">
        <!-- Name -->
        <payee-form-field width="max">
          <input
            payee-input
            formControlName="name"
            placeholder="Értesítés neve"
          />
          <span payee-label>Értesítés neve *</span>
          @if (form.get("name")?.invalid && form.get("name")?.dirty) {
            <span payee-error>Az értesítés neve kötelező</span>
          }
        </payee-form-field>

        <payee-dropdown
          formControlName="transition_group"
          width="max"
          [options]="transitionGroupOptions"
          [displayWith]="transitionGroupDisplayWith"
        >
          <span payee-label>Művelet csoport *</span>
          @if (form.get("transition_group")?.invalid && form.get("transition_group")?.dirty) {
            <span payee-error>A művelet csoport megadása kötelező</span>
          }
        </payee-dropdown>

        <div class="languages-management">
          <h3>Nyelvek kezelése</h3>

          <div class="add-language-section flex">
            <payee-form-field width="max">
              <payee-autocomplete
                placeholder="Válasszon nyelvet"
                [options]="countries"
                [displayWith]="countryDisplayWith"
                [formControl]="selectedLanguage"
              ></payee-autocomplete>
              <span payee-label>Nyelv hozzáadása</span>
            </payee-form-field>

            <button
              payee-icon-button
              type="button"
              color="white"
              [disabled]="!selectedLanguage.value || langs.contains(selectedLanguage.value.iso)"
              (click)="addLang()"
            >
              <payee-icon name="plus-blue"></payee-icon>
            </button>
          </div>

          <mat-accordion>
            @for (lang of addedLanguages; track lang) {
              <mat-expansion-panel
                class="language-panel"
                (opened)="selectLang(lang)"
              >
                <mat-expansion-panel-header>{{ lang }}</mat-expansion-panel-header>
                @if (getLangForm(lang); as langControl) {
                  <form [formGroup]="langControl">
                    <payee-form-field width="max">
                      <input
                        payee-input
                        formControlName="log_label"
                      />
                      <span payee-label>Események label *</span>
                      @if (langControl.controls.log_label.invalid && langControl.controls.log_label.dirty) {
                        <span payee-error>
                          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                        </span>
                      }
                    </payee-form-field>
                    <payee-form-field width="max">
                      <input
                        payee-input
                        formControlName="subject"
                      />
                      <span payee-label>Tárgy *</span>
                      @if (langControl.controls.subject.invalid && langControl.controls.subject.dirty) {
                        <span payee-error>
                          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                        </span>
                      }
                    </payee-form-field>
                    <payee-form-field width="max">
                      <input
                        payee-input
                        formControlName="title"
                      />
                      <span payee-label>Cím *</span>
                      @if (langControl.controls.title.invalid && langControl.controls.title.dirty) {
                        <span payee-error>
                          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                        </span>
                      }
                    </payee-form-field>
                    <payee-form-field width="max">
                      <textarea
                        payee-input
                        formControlName="message"
                        rows="4"
                      ></textarea>
                      <span payee-label>Üzenet *</span>
                      @if (langControl.controls.message.invalid && langControl.controls.message.dirty) {
                        <span payee-error>
                          {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                        </span>
                      }
                    </payee-form-field>
                    <mat-checkbox formControlName="is_containing_attachment">Tartalmaz mellékletet</mat-checkbox>
                    @if (errorMessage) {
                      <div class="error-message">
                        {{ errorMessage }}
                      </div>
                    }
                  </form>
                }
                <button
                  payee-button
                  width="shorter"
                  type="button"
                  color="alert-red"
                  (click)="removeLang(lang)"
                >
                  Törlés
                </button>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>

        <div class="process-states-management">
          <h3>Folyamatok és állapotok</h3>
          <mat-accordion class="process-list">
            @for (process of processes; track $index) {
              <mat-expansion-panel>
                <mat-expansion-panel-header [title]="process.name">
                  <mat-panel-title [class.bold-label]="getSelectedStatesCount(process) > 0">
                    {{ process.name }} ({{ getSelectedStatesCount(process) }}/{{ process.states.length }})
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="state-list">
                  @for (state of process.states; track state.class) {
                    <div class="state-item">
                      <mat-checkbox
                        [checked]="isProcessStateSelected(state.class)"
                        (change)="toggleProcessState(state.class)"
                      >
                        <div
                          class="state-label"
                          [title]="state.label"
                        >
                          {{ state.label }}
                        </div>
                      </mat-checkbox>
                    </div>
                  }
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      </div>

      <ng-template #payeePopupSubmitTemplate>
        <button
          width="max"
          payee-button
          type="submit"
          [disabled]="loading"
          (click)="onSubmit()"
        >
          Létrehozás
        </button>
      </ng-template>

      <ng-template #payeePopupCancelTemplate>
        <button
          width="max"
          payee-button
          type="button"
          [disabled]="loading"
          (click)="onCancel()"
        >
          Mégse
        </button>
      </ng-template>
    </form>
  } @else {
    <div class="dialog-loading flex vcenter hcenter">
      <mat-progress-spinner
        color="accent"
        diameter="40"
        mode="indeterminate"
      ></mat-progress-spinner>
    </div>
  }
</payee-popup>
